import store from '@/store';
import { inicializeDebugLog, handleDebugLog } from './utils';
import { getToken } from './auth';

// const API_URL = process.env.VUE_APP_API_URL || '';

async function makeApiRequest (path, method = 'GET', body = {}) {
  let debugLog = null;
  const params = {
    method: method,
    headers: {
      'content-Type': 'application/json',
      Authorization: `Bearer ${getToken()}`
    },
    body: Object.keys(body).length !== 0 ? JSON.stringify(body) : undefined
  };
  if (store.state.debugMode) {
    debugLog = inicializeDebugLog({ ...params, method: path });
  }
  return fetch(`${path}`, params)
    .then(response => response.json())
    .then(async response => {
      if (response && !response.success && store.state.debugMode) {
        debugLog.error = response;
        handleDebugLog(debugLog);
      }
      return response;
    }).catch(err => {
      console.log('errrr', err);
      return err;
    });
}

const pegaseWorkspaces = async () => makeApiRequest('/api/federated/workspaces', 'GET');

const getHorses = async workspace => makeApiRequest(`/api/federated/horse?workspace=${workspace}`, 'GET');

const getPlaces = async workspace => makeApiRequest(`/api/federated/places?workspace=${workspace}`, 'GET');

const getDisciplines = async workspace => makeApiRequest(`/api/federated/disciplines?workspace=${workspace}`, 'GET');

const getInstructors = async workspace => makeApiRequest(`/api/federated/instructors?workspace=${workspace}`, 'GET');

const equestrianReference = async () => makeApiRequest('/api/federated/references', 'GET');

const updateHorse = async horse => makeApiRequest('/api/federated/horse', 'POST', { ...horse, workspace: store.state.workspace.code });

const updateHorses = async horses => makeApiRequest('/api/federated/horse', 'POST', horses);

const getSiteInfo = async () => makeApiRequest(`/api/federated/site?workspace=${store.state.workspace.code}`, 'GET');

const updateCustomer = async customer => makeApiRequest('/api/customer', 'POST', { customer });

const getCustomerDetail = async id => makeApiRequest(`/api/customer?customer_uuid=${id}&workspace=${store.state.workspace.code}`, 'GET');

const updateCustomerAllowedProduct = async (customer_uuid, allowed_products) => {
  const workspace = store.state.workspace.code;
  return (makeApiRequest('/api/allowedProduct', 'POST', { customer_uuid, allowed_products, workspace }));
};

const addAllowedProductsToCustomers = async (customersUuids, allowedProducts, sendEmail) => {
  const workspace = store.state.workspace.code;
  return (makeApiRequest('/api/allowedProducts', 'POST', { customersUuids, allowedProducts, workspace, sendEmail }));
};

const onDemandRequest = async (customer_uuid, product_uuid, status, monitor, justification = null) => (makeApiRequest('/api/onDemandRequest', 'POST', { customer_uuid, product_uuid, justification, status, monitor }));

const deleteOnDemandRequest = async (customer_uuid, product_uuid) => (makeApiRequest('/api/OnDemand', 'POST', { customer_uuid, product_uuid }));

const getOnDemandCustomers = async () => makeApiRequest('/api/onDemandCustomers', 'GET');

// licenses

const refreshCustomerLicense = async customer_uuid => makeApiRequest(`/api/licenses?customer_uuid=${customer_uuid}&workspace=${store.state.workspace.code.toUpperCase()}`, 'GET');

const createCustomerLicense = async customer_uuid => makeApiRequest('/api/licenses', 'POST', { customer_uuid, workspace: store.state.workspace.code.toUpperCase() });

const renewCustomerLicense = async (customer_uuid, pegase_license_code) => makeApiRequest('/api/renewLicenses', 'POST', { customer_uuid, pegase_license_code, workspace: store.state.workspace.code.toUpperCase() });

const getCustomersLicensesToActivate = async () => makeApiRequest(`/api/customersLicense?workspace=${store.state.workspace.code}`, 'GET');

const activateCustomersLicenses = async customers => makeApiRequest('/api/customersLicense', 'POST', { customers });

const refreshLicense = async licenses => {
  const workspace = store.state.workspace.code;
  return makeApiRequest('/api/federated/refreshLicenses', 'POST', { licenses, workspace });
};

// endLicenses

const getCustomerAllInsurance = async customer_uuid => makeApiRequest(`/api/insurances?customerUuid=${customer_uuid}&workspace=${store.state.workspace.code}`, 'GET');

const getInsuranceFile = async url => makeApiRequest(`/api/federated/insurance?url=${encodeURIComponent(url)}`, 'GET');

const getCustomerLicense = async customer_uuid => makeApiRequest(`/api/customerLicense?customerUuid=${customer_uuid}&workspace=${store.state.workspace.code}`, 'GET');

const modifyContractProduct = async ({ contractNumber, customerUuid, newProperties }) => makeApiRequest('/api/federated/modifyContract', 'POST', { contractNumber, customerUuid, workspace: store.state.workspace.code, newProperties, collaboratorUuid: store.state.user.uuid });

const openSearchProducts = async (workspace = store.state.workspace) => makeApiRequest(`/api/federated/searchOpenSearch?workspace=${workspace.code}`, 'GET');

const getFederatedProductDetail = async uuid => makeApiRequest(`/api/federated/product?uuid=${uuid}`, 'GET');

const getContractWithStock = async customerUuid => {
  const { workspace } = store.state;
  return makeApiRequest(`/api/federated/customerContractsWithStock?workspace=${workspace.code}&customerUuid=${customerUuid}`, 'GET');
};

const getPensionContracts = async (start, end) => {
  const { workspace } = store.state;
  return makeApiRequest(`/api/federated/pensionContracts?workspace=${workspace.code}&start=${start}&end=${end}`, 'GET');
};

const updateCollaborator = async body => makeApiRequest('/api/federated/collaborator', 'PUT', { ...body });

const getSiteByUrl = async url => makeApiRequest(`/api/federated/site?url=${url}`, 'GET');

const impersonateMode = async (customer, collaborator, workspace) => makeApiRequest('/api/impersonateMode', 'POST', { customer, collaborator, workspace });

const getHolidaysByPeriod = async (start, end, workspace) => makeApiRequest(`/api/federated/holiday?start=${start}&end=${end}&workspace=${workspace}`, 'GET');

const createHoliday = async body => makeApiRequest('/api/federated/holiday', 'POST', body);
const updateHoliday = async body => makeApiRequest('/api/federated/holiday', 'PUT', body);
const deleteHoliday = async body => makeApiRequest('/api/federated/holiday', 'DELETE', body);

const getEmailTemplate = async () => makeApiRequest(`/api/federated/pegaseEmail?workspace=${store.state.workspace.code}`, 'GET');
const sendEmail = async body => makeApiRequest('/api/federated/pegaseEmail', 'POST', body);

const getClientsReceivedEmails = async emailUuid => makeApiRequest(`/api/federated/email?workspace=${store.state.workspace.code}&email=${emailUuid}`);

const getCustomersByUUids = async (uuids, extraProperties = null) => makeApiRequest('/api/customers', 'POST', { uuids, extraProperties });

const getLevels = async (start = 0, limit = 1000) => makeApiRequest(`/api/federated/level?start=${start}&limit=${limit}&workspace=${store.state.workspace.code}`, 'GET');

const getCustomersPaymentStatus = async contracts => {
  const workspace = store.state.workspace.code;
  if (!contracts || !contracts.length) {
    return [];
  }
  return makeApiRequest('/api/federated/orders', 'POST', { contracts, workspace });
};

// falls
const getWorkspaceFalls = async (start, end) => makeApiRequest(`/api/federated/fall?workspace=${store.state.workspace.code}&start=${start}&end=${end}`, 'GET');
const getCustomerFall = async customerUuid => makeApiRequest(`/api/federated/customerFall?workspace=${store.state.workspace.code}&customerUuid=${customerUuid}`, 'GET');
const deleteFall = async (ridder, workspace, uuid) => makeApiRequest('/api/federated/fall', 'DELETE', { ridder, workspace, uuid });
const createFall = async fall => makeApiRequest('/api/federated/fall', 'POST', { fall });
const editFall = async fall => makeApiRequest('/api/federated/fall', 'PUT', { fall });

// ffe feed
const getFFeFeed = async () => makeApiRequest('/api/federated/ffeFeed', 'GET');

const getCustomerHorseHistory = async ({ customerUuid, date, size }) => makeApiRequest(`/api/federated/customerHorse?workspace=${store.state.workspace.code}&customerUuid=${customerUuid}&date=${date}&size=${size}`, 'GET');

const deleteLicenseDynamo = async (customerUuid, licenseYear) => makeApiRequest('/api/federated/deleteLicense', 'POST', { customerUuid, licenseYear });

const createReportUploadUrl = async () => makeApiRequest('/api/federated/report', 'POST', { workspace: store.state.workspace?.code, collaboratorUuid: store.state.user?.uuid });

const uploadReportToS3 = async (url, file) => makeApiRequest('/api/federated/report', 'PUT', { url, file });

const getProductRecuperations = async (customerUuid, contractNumber) => makeApiRequest(`/api/federated/productRecuperations?workspace=${store.state.workspace?.code?.toUpperCase()}&customerUuid=${customerUuid}&contractNumber=${contractNumber}`, 'GET');

const createProductRecuperation = async (customerUuid, contractNumber, product) => makeApiRequest('/api/federated/productRecuperations', 'POST', { customerUuid, workspace: store.state.workspace?.code, contractNumber, product });

const getContractByNumber = async (customerUuid, contractNumber) => makeApiRequest(`/api/federated/contract?customerUuid=${customerUuid}&contractNumber=${contractNumber}`, 'GET');

const preReservationsDeletionDebug = async (preReservations, workspace = store.state.workspace.code, collaboratorUuid = store.state.user.uuid) => makeApiRequest('/api/federated/preReservations', 'POST', { preReservations, workspace, collaboratorUuid });

const restoreStock = async (session, typeOfUpdate, participantToRemoveUuid, contractNumber, workspace = store.state.workspace.code) => makeApiRequest('/api/federated/restoreStock', 'POST', { session, typeOfUpdate, participantToRemoveUuid, contractNumber, workspace });

const getCustomerYearlyProductRecuperations = async (customerUuid, start, end) => makeApiRequest(`/api/federated/customerProductRecuperations?workspace=${store.state.workspace?.code?.toUpperCase()}&customerUuid=${customerUuid}&start=${start}&end=${end}`, 'GET');

const getWorkspaceSentEmailsByPeriod = async (startDate, endDate) => makeApiRequest(`/api/federated/emails?workspace=${store.state.workspace.code}&startDate=${startDate}&endDate=${endDate}`, 'GET');

const createHorseCareUploadUrl = async (horseUuid, sessionId, fileName) => makeApiRequest('/api/federated/horseCare', 'POST', { workspace: store.state.workspace?.code, horseUuid, sessionId, fileName, collaboratorUuid: store.state.user?.uuid });

const uploadHorseCareToS3 = async (url, file) => {
  const response = await fetch('/api/federated/horseCare', {
    method: 'PUT',
    headers: { Authorization: `Bearer ${store.state.token}`, 'X-S3-Url': url, 'X-Content-Type': file.type },
    body: file
  });
  return response.json();
};

const getHorseCareListing = async (horseUuid, sessionId) => makeApiRequest(`/api/federated/horseCare?workspace=${store.state.workspace?.code}&horseUuid=${horseUuid}&sessionId=${sessionId}`, 'GET');

const getHorseCareDocumentUrl = async (horseUuid, sessionId, fileName) => makeApiRequest(`/api/federated/horseCare?workspace=${store.state.workspace?.code}&horseUuid=${horseUuid}&sessionId=${sessionId}&fileName=${fileName}`, 'GET');

const downloadS3File = async url => {
  const response = await fetch(`/api/federated/s3Operations?url=${encodeURIComponent(url)}`, { method: 'GET', headers: { Authorization: `Bearer ${store.state.token}` } });

  if (!response.ok) {
    throw new Error('Erreur lors du téléchargement du document');
  }

  return response.blob();
};

const deleteHorseCareDocument = async (horseUuid, sessionId, fileName) => makeApiRequest('/api/federated/horseCare', 'DELETE', { horseUuid, sessionId, fileName, workspace: store.state.workspace?.code });

// alpha orders

const getOrders = async (start, limit, customerId, orderSrc, statusFilter) => {
  const workspace = store.state.workspace.code;
  let req = `/api/orders?start=${start || 0}&limit=${limit || 10}&customer_id=${customerId}&orderSrc=${orderSrc}&workspace=${workspace}`;
  if (statusFilter && statusFilter !== 'All') {
    req = `${req}&statusFilter=${statusFilter}`;
  }
  return makeApiRequest(req, 'GET');
};

const changeContractStockBalance = async (customerUuid, contractNumber, oldStock, newStock, collaboratorUuid, observation) => makeApiRequest('/api/federated/contractStock', 'POST', { customerUuid, contractNumber, oldStock, newStock, collaboratorUuid, observation });

const getContractStockHistory = async (customerUuid, contractNumber) => makeApiRequest(`/api/federated/contractStock?customerUuid=${customerUuid}&contractNumber=${contractNumber}`, 'GET');

const changeContractHistoryObservation = async ({ contractNumber, timestamp, newObservation }) => makeApiRequest('/api/federated/contractStock', 'PUT', { contractNumber, timestamp, newObservation });

const getContractSessions = async (contractNumber, workspace, startDate, endDate) => makeApiRequest(`/api/federated/contractSessions?contractNumber=${contractNumber}&workspace=${workspace}&startDate=${startDate}&endDate=${endDate}`, 'GET');

const updateContractEndValidity = async (customerUuid, contractNumber, newEndDate, collaboratorUuid) => makeApiRequest('/api/federated/contractsValidity', 'POST', { customerUuid, contractNumber, newEndDate, collaboratorUuid });

const getContractValidityHistory = async contractNumber => makeApiRequest(`/api/federated/contractsValidity?contractNumber=${contractNumber}`, 'GET');

export {
  getFederatedProductDetail,
  openSearchProducts,
  pegaseWorkspaces,
  getFFeFeed,
  getCustomerFall,
  editFall,
  createFall,
  deleteFall,
  getWorkspaceFalls,
  getCustomersByUUids,
  getClientsReceivedEmails,
  getEmailTemplate,
  sendEmail,
  createHoliday,
  getHolidaysByPeriod,
  updateHoliday,
  deleteHoliday,
  getCustomerLicense,
  activateCustomersLicenses,
  getCustomersLicensesToActivate,
  impersonateMode,
  getContractWithStock,
  getSiteInfo,
  getSiteByUrl,
  getCustomerDetail,
  renewCustomerLicense,
  createCustomerLicense,
  refreshCustomerLicense,
  getOnDemandCustomers,
  deleteOnDemandRequest,
  onDemandRequest,
  updateCustomerAllowedProduct,
  updateCustomer,
  equestrianReference,
  updateHorse,
  updateCollaborator,
  getCustomerAllInsurance,
  getLevels,
  getCustomersPaymentStatus,
  getInsuranceFile,
  modifyContractProduct,
  getCustomerHorseHistory,
  deleteLicenseDynamo,
  refreshLicense,
  getPensionContracts,
  updateHorses,
  createReportUploadUrl,
  uploadReportToS3,
  getProductRecuperations,
  createProductRecuperation,
  getContractByNumber,
  preReservationsDeletionDebug,
  restoreStock,
  getCustomerYearlyProductRecuperations,
  getHorses,
  getPlaces,
  getDisciplines,
  getInstructors,
  addAllowedProductsToCustomers,
  getWorkspaceSentEmailsByPeriod,
  createHorseCareUploadUrl,
  uploadHorseCareToS3,
  getHorseCareListing,
  getHorseCareDocumentUrl,
  downloadS3File,
  deleteHorseCareDocument,
  getOrders,
  changeContractStockBalance,
  getContractStockHistory,
  changeContractHistoryObservation,
  getContractSessions,
  updateContractEndValidity,
  getContractValidityHistory
};
